Customer.Ticket ||= {}

class Customer.Ticket.InteractionScheduleSuspendedByNewInteractionDetailsView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/interaction_schedule/interaction_schedule_suspended_by_new_interaction_details']
  className: 'interaction-schedule-details suspended-by-new-interaction'

  initialize: (@options = {}) ->
    @schedule = @options.schedule

  render: ->
    @$el.html(@template(@schedule))
    @
